import { styled } from '@mui/material/styles';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export const RootStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  color: '#1c1c1c',
  minHeight: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  fontSize: 18,
  fontFamily: theme.typography.h4.fontFamily,
}));

export const LogoStyled = styled('img')({
  width: '150px',
  marginBottom: '80px',
});

export const TextStyled = styled('p')({
  textAlign: 'center',
  maxWidth: '80%',
  margin: '0 auto',
});

export const NewTokenBtn = styled(Button)({
  color: '#FFF',
  marginTop: '20px',
});
